'use strict';

/* global $ */

function Map(options) {

    let opt = $.extend(true, {}, options);

    function initBlock(el) {
        let $el = $(el);

        let location = $el.data('location').split(',');
        //let latitude = location[0];
        //let longitude = location[1];
        console.log(location);
        opt = $.extend({
            mapSelector: opt.selector+'__block',
            itemSelector: opt.selector+'__item',
            //behaviors: opt.behaviors,
            //controls: opt.controls,
            center: location,
            //zoom: opt.zoom,
            eps: .005
        }, opt);

        let myMap, $map;
        let placemarks = {};

        $map = $(opt.mapSelector);
        if (!$map.length) return;
        console.log('[ Map/init ]');

        let items = {};
        $(opt.itemSelector, this).each(function(i) {
            let id = $(this).data('id');
            let data = $(this).data();
            data.coords = data.coords.replace(' ', '');
            data.coords = data.coords.split(',');
            console.log(data.coords);
            items[id] = data;
            items[id].info = $(this).html();
        });

        myMap = new ymaps.Map($map.get(0), opt, {yandexMapDisablePoiInteractivity: true});

        //myMap = new ymaps.Map($map.get(0), {
        //    behaviors: opt.behaviors,
        //    controls: opt.controls,
        //    center: opt.center,
        //    zoom: opt.zoom
        //});

        //myMap.controls.add('zoomControl');
        //myMap.controls.add('typeSelector');

        $map.mouseenter(function(e) {
            myMap.behaviors.disable('scrollZoom');
        });

        let MyBalloonLayout = ymaps.templateLayoutFactory.createClass(
            '<div class="map__popover">' +
            '<a class="map__popover-close" href="#">&times;</a>' +
            '<div class="map__popover-inner">' +
            '$[[options.contentLayout observeSize minWidth=280 maxWidth=320 maxHeight=350]]' +
            '</div>' +
            '</div>', {
            build: function () {
                this.constructor.superclass.build.call(this);

                this._$element = $('.map__popover', this.getParentElement());

                this.applyElementOffset();

                this._$element.find('.map__popover-close')
                    .on('click', $.proxy(this.onCloseClick, this));
            },
            clear: function () {
                this._$element.find('.map__popover-close')
                    .off('click');

                this.constructor.superclass.clear.call(this);
            },
            onSublayoutSizeChange: function () {
                MyBalloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);

                if (!this._isElement(this._$element)) {
                    return;
                }

                this.applyElementOffset();

                this.events.fire('shapechange');
            },
            applyElementOffset: function () {
                this._$element.css({
                    left: -(this._$element[0].offsetWidth / 2),
                    top: -(this._$element[0].offsetHeight)
                });
            },
            onCloseClick: function (e) {
                e.preventDefault();

                this.events.fire('userclose');
            },
            getShape: function () {
                if (!this._isElement(this._$element)) {
                    return MyBalloonLayout.superclass.getShape.call(this);
                }
                let position = this._$element.position();
                return new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([
                    [position.left, position.top], [
                        position.left + this._$element[0].offsetWidth,
                        position.top + this._$element[0].offsetHeight
                    ]
                ]));
            },
            _isElement: function (element) {
                return element && element[0];
            }
        });

        let MyBalloonContentLayout = ymaps.templateLayoutFactory.createClass(
            '$[properties.balloonContent]'
        );

        let geoobjects = [];
        for (let j in items) {
            if (items[j].coords.length == 2) {
                let myGeoObject = new ymaps.GeoObject({
                        geometry: {
                            type: "Point",
                            coordinates: items[j].coords
                        },
                        properties: {
                            //clusterCaption: annotation,
                            //content: items[j].info,
                            balloonContent: items[j].info,
                        }
                    }, {
                        balloonShadow: false,
                        balloonLayout: MyBalloonLayout,
                        balloonContentLayout: MyBalloonContentLayout,
                        balloonPanelMaxMapArea: 0,
                        hideIconOnBalloonOpen: true,
                        //iconLayout: 'default#image',
                        //iconImageHref: opt.icon,
                        //iconImageSize: [100, 100],
                        //iconImageOffset: [-50, -50],
                });
                geoobjects.push(myGeoObject);
            }
        }

        if (geoobjects.length) {
            let clusterer = new ymaps.Clusterer({clusterDisableClickZoom: false});
            clusterer.add(geoobjects);
            myMap.geoObjects.add(clusterer);
            console.log('[ Map/Set Geo Object ]');
        }
        myMap.setBounds(myMap.geoObjects.getBounds(), {
            checkZoomRange: true,
            zoomMargin: 50
        }).then(function(){ if(myMap.getZoom() > 14) myMap.setZoom(14);});
    }

    if ($(opt.selector).length == 0) return;
    if (typeof ymaps !== 'undefined') {
        ymaps.ready(function() {
            $(opt.selector).each(function() {
                initBlock(this);
            });
        });
    } else {
        let count = 0;
        let timerId = setInterval(function() {
            count++;
            console.log('[ Map/test ] ' + count);
            if (typeof ymaps !== 'undefined') {
                ymaps.ready(function() {
                    $(opt.selector).each(function() {
                        initBlock(this);
                    });
                });
                clearInterval(timerId);
            }
            if (count > 2) {
                clearInterval(timerId);
            }
        }, 500);
    }
}

export {
    Map
};
